<!-- Central Details -->
<template>
    <b-modal
      v-if="currentCent != null"
      :visible="visible"
      @show="initModal"
      @hidden="hide"
      @change="change"
      scrollable
      ref="modal_cent_details"
      id="modal-cent-details"
      no-close-on-backdrop
      :title="$t('unit_details_modal.title', {tipo: currentCent.cu_type, id: currentCent.cu_id})"
      :ok-only="true"
      :ok-title="$t('close')"
    >
<!-- scheda descrittiva in alto -->
    <b-container fluid>
        <b-row>
            <b-col v-if="currentCent.cu_product_image" cols="4" class="my-auto text-center"><img  :src="pathDeviceImages  + currentCent.cu_product_image" style="height:60px; width:auto;" /></b-col>
            <b-col v-else cols="4" class="my-auto text-center">
                <img  v-if="currentCent.cu_type=='logicafm'" :src="'/img/logicafmsd/centrale.png'" style="height:60px; width:auto;" />
                <img  v-if="currentCent.cu_type=='logica'" :src="'/img/logica/centrale.png'" style="height:60px; width:auto;" />
                <img  v-if="currentCent.cu_type=='cablecom'" :src="'/img/cablecom/centrale.png'" style="height:60px; width:auto;" />
                <img  v-if="currentCent.cu_type=='sicuro'" :src="pathDeviceImages  + 'cu_sicuro.jpg'" style="height:60px; width:auto;" />
                <img  v-if="currentCent.cu_type=='blegateway'" :src="'/img/blegateway/bleGateway.jpg'" style="height:60px; width:auto;" />
            </b-col>
            <b-col cols="8">
                <b-row>
                    <b-col cols="3">
                        <b-row><b-col cols="12">{{$t("details_cu_modal.cu_type")}}</b-col></b-row>
                        <b-row><b-col cols="12"><strong>{{currentCent.cu_type}}</strong></b-col></b-row>
                    </b-col>
                    <b-col cols="3">
                        <b-row><b-col cols="12"><span class="m-2">{{$t("details_cu_modal.cu_id")}}</span></b-col></b-row>
                        <b-row><b-col cols="12"><strong><span class="m-2">{{currentCent.cu_id}}</span></strong></b-col></b-row>
                    </b-col>
                    <b-col cols="6">
                        <b-row>
                            <b-col cols="12">
                                <div>
                                    <b-row><b-col cols="6"></b-col><b-col cols="6">
                                        <!-- :disabled="this.currentCent.cu_type == 'sicuro'" -->
                                    <b-button  @click="checkFwUpgrade"><i class="fa fas fa-refresh" style="color:#009DE0"></i></b-button>
                                    </b-col></b-row>
                                    <b-row><b-col cols="3"></b-col><b-col cols="8">
                                    <div class="typo-littleblue">{{ $t('check_update')}}</div>
                                    </b-col></b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col cols="12">
                        <b-row><b-col cols="12">{{$t("details_cu_modal.cu_descrizione")}}</b-col></b-row>
                        <b-row>
                            <b-col v-if="!editingCentLocal" cols="10"><strong>{{currentCent.cu_desc ? currentCent.cu_desc: nomeCent}}</strong></b-col>
                            <b-col v-if="!editingCentLocal" cols="2"><b-button @click="editNomeCent"><i class="fa fa-edit"></i></b-button></b-col>
                            <b-col v-if="editingCentLocal" cols="8">
                                <div role="group">
                                <b-form-input id="centName" type="text" v-model="nomeCent"></b-form-input>
                                <b-form-text v-html="centNameInfo"></b-form-text>
                                </div>
                            </b-col>
                            <b-col v-if="editingCentLocal" cols="4">
                                <b-button v-if="!updatingNameLocal" @click="saveNomeCent"><i class="fa fa-check"></i></b-button>
                                <b-button v-if="!updatingNameLocal" @click="abortNomeCent" ><i class="fa fa-close"></i></b-button>
                                <span v-if="updatingNameLocal"><i class="fa fa-spinner fa-spin"></i></span>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
    <hr>

    <!--- se cu è una centrale -->
    <b-container fluid v-if="currentCent.cu_error">
        <b-row > <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade")}}:</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_found}}</b-col></b-row>
        <b-row v-if="currentCent.num_lamp_present"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_presenti")}}:</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_present}}</b-col></b-row>
        <b-row v-if="currentCent.lamps_id && currentCent.lamps_id.length >0"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_emergenza")}}:</b-col><b-col cols="2" sm="5">{{currentCent.lamps_id.length}}</b-col></b-row>
        <b-row v-if="currentCent.lamps_illum_id && currentCent.lamps_illum_id.length >0"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_illuminazione")}}:</b-col><b-col cols="2" sm="5">{{currentCent.lamps_illum_id.length}}</b-col></b-row>
        <b-row v-if="currentCent.lamps_altro_id && currentCent.lamps_altro_id.length >0"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_sensori")}}:</b-col><b-col cols="2" sm="5">{{currentCent.lamps_altro_id.length}}</b-col></b-row>
        <b-row v-if="currentCent.cu_type=='logicafm'"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_errore")}}:</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_error + currentCent.num_nodi_orfani}}</b-col></b-row>
        <b-row v-else> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_errore")}}:</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_error == null ? 0 : currentCent.num_lamp_error}}</b-col></b-row>
        <!-- sicuro  -->
        <b-row v-if="currentCent.V"><b-col cols="10" offset-sm="1" sm="6">{{ $t("details_cu_modal.voltage") }}: </b-col><b-col cols="2" sm="5">{{ currentCent.V }} V</b-col></b-row>
        <b-row v-if="currentCent.I"><b-col cols="10" offset-sm="1" sm="6">{{ $t("details_cu_modal.current") }}: </b-col><b-col cols="2" sm="5">{{ currentCent.I }} mA</b-col></b-row>

    <!-- </b-container> -->
        <br>
    <!-- <b-container fluid v-if="currentCent.cu_error"> -->
        <b-row  v-if='currentCent.cu_status.emergency_running=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle emergency-on mr-2 mb-3"></i>{{$t("details_cu_modal.emergency_on")}}</b-col></b-row>
<!-- Errors found -->
        <b-row ><b-col cols="12" offset-sm="1" sm="10"><strong>{{$t("details_cu_modal.cu_error")}}</strong></b-col></b-row>
        <b-row  v-if='currentCent.cu_error.error_batt_low_voltage=="ON" && currentCent.cu_error.error_batt_not_connected=="OFF"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_low_voltage")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.error_batt_not_connected=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_not_connected")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.error_duplicated_id_lamp=="ON"'><b-col scols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_duplicated_id_lamp")}}</b-col></b-row>

        <b-row  v-if='(currentCent.cu_error.error_lg === "ON" || currentCent.num_lamp_error>0 || currentCent.num_nodi_orfani>0) && currentCent.cu_type !== "sicuro"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_lg")}}</b-col></b-row>
        <!-- <b-row  v-if="currentCent.cu_type == 'sicuro' && calcolaLampInError(currentCent)"><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_lg")}}</b-col></b-row> -->

        <b-row  v-if='currentCent.cu_error.error_wiring=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_wiring")}}</b-col></b-row>
        <b-row class="m-2" v-if='currentCent.cu_error.error_too_much_lamp_in_config=="ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_error_too_much_lamp_in_config")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.error_overload=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_overload")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.error_missing_lamp_in_config=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_error_missing_lamp_in_config")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.error_more_32_lamp_in_config=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_more_32_lamp_in_config")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.error_more_128_lamp_in_config=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_more_128_lamp_in_config")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_data_invalid=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_date_time_invalid")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART1=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART1")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART2=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART2")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART3=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART3")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART3_modem_powerON=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_modem_off")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART4=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART4")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART5=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART5")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART6=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART6")}}</b-col></b-row>
        <b-row  v-if='currentCent.cu_error.err_UART7=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART7")}}</b-col></b-row>

        <b-row v-if='currentCent.cu_error.error_ak_o_luci == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_subdisp")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_battery_fuse == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_fuse")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_battery_low == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_low_voltage")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_battery_symmetry == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_simm")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_battery_temperature == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_temp")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_io_measures == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_io_measures")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_com_cpu_io == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_com_IO")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_com_cpu_ak == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_com_cpu_AK")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_com_cpu_akext == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_com_cpu_AKext")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_com_cpu_switch11kw == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_com_switch11kw")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_com_cpu_charger == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_com_charger")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_com_cpu_lssa == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_com_lssa")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_com_cpu_substation == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_com_sub")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_all_chargers_or_fuse == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_all_chargers")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_chargers=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_caricatori")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_cabinet_isominus == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_isominus")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_cabinet_isoplus == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_isoplus")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_line_isolation == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_line_isol")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_lamp_programming == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_prog_lamp")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_autonomy_test == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_last_duration_test")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_functional_test == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_last_funz_test")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_power_supply_broken == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_power_supply_broken")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.error_power_supply_out_of_range == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_power_supply_out_of_range")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.warning_charger_off_by_temperature == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_charger_off_by_temp")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.warning_maintenance == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_maintenance")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.no_mains == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_no_main")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.no_phase1 == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_no_phase1")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.no_phase2 == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_no_phase2")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.no_phase3 == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_no_phase3")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.system_inhibited == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_system_inhibited")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.no_subdistribution == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_sub_dis")}}</b-col></b-row>
        <b-row v-if='currentCent.cu_error.no_critical_circuit == "ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_warning_critical")}}</b-col></b-row>

        <b-row v-if="NessunErroreCentrale(currentCent.cu_type)">
            <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_cu_modal.cu_no_error")}}</b-col>
        </b-row>
        <b-row v-if='currentCent.cu_error.system_inhibited == "ON"'>
            <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{ $t("details_cu_modal.cu_inHibited") }}</b-col>
        </b-row>
        <b-row v-if='currentCent.cu_type=="logicafm" && currentCent.cu_error.mancanza_rete=="ON"'>
            <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.MANCANZA_RETE")}}</b-col>
        </b-row>
    <!-- </b-container> -->
<!-- Details -->
    <!-- <b-container fluid> -->
        <hr v-if="currentCent.cu_product_desc">
        <b-row v-if="currentCent.cu_product_desc"><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t('details_cu_modal.details')}}</strong></b-col></b-row>
        <b-row v-if="currentCent.cu_product_desc"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.product_desc")}}: </b-col><b-col>{{currentCent.cu_product_desc}}</b-col></b-row>
        <b-row v-if="currentCent.cu_product_desc === 'SUBSTATION 230'"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.mainstation_associated_id")}}: </b-col><b-col>{{currentCent.mainstation_associated_id}}</b-col></b-row>
        <b-row v-if="currentCent.substation_id != null"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.substation_id")}}: </b-col><b-col><ul style="padding-left: 0px"><li v-for="subid in currentCent.substation_id" :key="subid">{{subid}}</li></ul></b-col></b-row>
        <b-row v-if="currentCent.cu_order_code"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.order_code")}}: </b-col><b-col>{{currentCent.cu_order_code}}</b-col></b-row>
        <b-row v-if="currentCent.cu_product_code"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.product_code")}}: </b-col><b-col>{{currentCent.cu_product_code}}</b-col></b-row>
        <b-row v-if="currentCent.cu_battery_code"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.battery_code")}}: </b-col><b-col>{{currentCent.cu_battery_code}}</b-col></b-row>
        <b-row v-if="currentCent.cu_battery_desc"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.battery_desc")}}: </b-col><b-col>{{currentCent.cu_battery_desc}}</b-col></b-row>
        <b-row v-if="currentCent.cu_dimension"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.dimension")}}: </b-col><b-col>{{currentCent.cu_dimension}}</b-col></b-row>
    <!-- scheda pdf -->
        <b-row>
            <b-col offset-sm="1"  sm="4" v-if="currentCent.cu_product_pdf!=null && currentCent.cu_product_pdf!='undefined' && currentCent.cu_product_pdf!=''">{{$t("details_cu_modal.cu_pdf")}}:</b-col>
            <b-col v-if="currentCent.cu_product_pdf!=null && currentCent.cu_product_pdf!='undefined' && currentCent.cu_product_pdf!=''">
                <a :href="pathDevicePdf+currentCent.cu_product_pdf" target="_blank">
                    <span class="mr-1"><i class="fa fa-file" style="color:#009DE0"></i></span>
                    {{currentCent.cu_product_pdf}}
                </a>
            </b-col>
        </b-row>
        <hr>
<!-- Planning automatic tests -->
        <b-row><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t('pianifica_test_modal.title')}}</strong></b-col></b-row>
        <b-row><b-col offset-sm="1" sm="6">{{$t("details_cu_modal.cu_prossimo_test_funzionale")}}:</b-col>
        <b-col  v-if="currentCent.cu_type=='blegateway'" sm="4">
            {{moment.parseZone(currentCent.cu_next_funct_test).format('DD MMM YYYY - HH:mm')}} <span class="typo-littleblack">{{currentCent.cu_location}} </span>
        </b-col>
        <b-col  v-else sm="4">
            {{moment(currentCent.cu_next_funct_test).format('DD MMM YYYY - HH:mm')}} <span class="typo-littleblack">{{currentCent.cu_location}} </span>
        </b-col>
        </b-row>
        <b-row><b-col offset-sm="1" sm="6">{{$t("details_cu_modal.cu_prossimo_test_autonomia")}}:</b-col>
        <b-col  v-if="currentCent.cu_type=='blegateway'" sm="4">
            {{moment.parseZone(currentCent.cu_next_auto_test).format('DD MMM YYYY - HH:mm')}}  <span class="typo-littleblack">{{currentCent.cu_location}} </span>
        </b-col>
        <b-col  v-else sm="4">
            {{moment(currentCent.cu_next_auto_test).format('DD MMM YYYY - HH:mm')}}  <span class="typo-littleblack">{{currentCent.cu_location}} </span>
        </b-col>
        </b-row>
        <b-row><b-col offset-sm="1" cols="9" sm="6">{{$t("details_cu_modal.cu_periodicita_test_funzionale")}}:</b-col><b-col cols="3" sm="5">{{ currentCent.cu_period_funct_test ? currentCent.cu_period_funct_test + " gg" : $t("details_cu_modal.not_available") }} </b-col></b-row>
        <b-row><b-col offset-sm="1" cols="9" sm="6">{{$t("details_cu_modal.cu_periodicita_test_autonomia")}}:</b-col><b-col  cols="3" sm="5">{{ currentCent.cu_period_auto_test ? currentCent.cu_period_auto_test + " gg" : $t("details_cu_modal.not_available") }} </b-col></b-row>
        <b-row v-if="currentCent.cu_status.test_differito"><b-col offset-sm="1" cols="9" sm="6">{{$t("details_cu_modal.test_differito")}}:</b-col><b-col cols="3" sm="5">{{currentCent.cu_status.test_differito}}</b-col></b-row>
        <hr>
<!-- Technical specification -->
        <b-row ><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t("details_cu_modal.specifiche_tecniche")}}</strong></b-col></b-row>
        <b-row v-if="currentCent.timezone"><b-col offset-sm="1"  sm="6">Timezone: </b-col><b-col  sm="5">{{currentCent.timezone}}</b-col></b-row>

        <!-- Dettagli software per logica e cablecom -->
       <div v-if="currentCent.cu_type == 'logica' || currentCent.cu_type == 'cablecom'">
            <b-row>
                <b-col offset-sm="1"  sm="6">{{ $t("details_cu_modal.core_firmware_ver")}}: </b-col>
                <b-col  sm="5">{{currentCent.cu_sw_ver.cu_sw_id.toString().includes(".")?currentCent.cu_sw_ver.cu_sw_id.split(".")[0]:currentCent.cu_sw_ver.cu_sw_id}} Build:{{currentCent.cu_sw_ver.cu_sw_build}}</b-col>
            </b-row>
            <b-row v-if="currentCent.cu_sw_ver && currentCent.cu_sw_ver.upgradable=='YES'">
                <b-col offset="1" cols="12" style="text-align:left; color:#009DE0">
                <b-button v-if="currentCent.modwifi_sw_ver && currentCent.modwifi_sw_ver.upgradable=='NO'" @click="startFwUpgrade" style="padding:0px;"><i class="fa fa-refresh mr-1" style="text-align:left; color:#009DE0"></i></b-button>
                    <span>{{ $t("details_cu_modal.core_firmware_available") }}. {{ $t("build")}}: {{currentCent.cu_sw_ver.cu_sw_build_fw_upg}} </span>
                </b-col>
            </b-row>
            <b-row v-if="currentCent.cu_sw_ver && currentCent.cu_sw_ver.cu_sw_feedback_fw_upg !== 'OTA_UPGRADE_OK'"><b-col offset="1" cols="12" style="text-align:left;color:red" class="typo-littleblack">{{ $t("details_cu_modal.update_failed") }}: {{ currentCent.cu_sw_ver.cu_sw_feedback_fw_upg }}</b-col></b-row>
            <b-row v-else><b-col offset="1" cols="12" style="text-align:left;color:grey" class="typo-littleblack">{{ $t("details_cu_modal.core_firmware_updated") }}</b-col></b-row>

            <b-row v-if="currentCent.modwifi_sw_ver" class="mt-2"><b-col offset-sm="1"  sm="6">{{ $t("details_cu_modal.wifi_firmware_ver") }}: </b-col><b-col  sm="5">{{currentCent.modwifi_sw_ver.modwifi_sw_id.toString().includes(".")?currentCent.modwifi_sw_ver.modwifi_sw_id.split(".")[0]:currentCent.modwifi_sw_ver.modwifi_sw_id}} Build:{{currentCent.modwifi_sw_ver.modwifi_sw_build}}</b-col></b-row>
            <b-row v-if="currentCent.modwifi_sw_ver && currentCent.modwifi_sw_ver.upgradable=='YES'">
                <b-col offset="1" cols="12" style="text-align:left; color:#009DE0">
                <b-button @click="startFwUpgrade" style="padding:0px;"><i class="fa fa-refresh mr-1" style="text-align:left; color:#009DE0"></i></b-button>
                    <span>{{ $t("details_cu_modal.wifi_firmware_available") }}. {{ $t("build")}}: {{currentCent.modwifi_sw_ver.modwifi_sw_build_fw_upg}} </span>
                </b-col>
            </b-row>
            <b-row v-if="currentCent.modwifi_sw_ver && currentCent.modwifi_sw_ver.modwifi_sw_feedback_fw_upg !== 'OTA_UPGRADE_OK'"><b-col offset="1" cols="12" style="text-align:left;color:red" class="typo-littleblack"> {{ $t("details_cu_modal.update_failed") }}: {{ currentCent.modwifi_sw_ver.modwifi_sw_feedback_fw_upg }} </b-col></b-row>
            <b-row v-else><b-col offset="1" cols="12" style="text-align:left;color:grey" class="typo-littleblack"> {{ $t("details_cu_modal.wifi_firmware_updated") }} </b-col></b-row>
        </div>

        <!-- Dettagli software logicafm -->
       <div v-if="currentCent.cu_type=='logicafm'">
            <b-row>
                <b-col offset-sm="1"  sm="6">Firmware version: </b-col>
                <b-col  sm="5">{{currentCent.cu_sw_ver ? currentCent.cu_sw_ver.cu_sw_id : 'n/a'}}</b-col>
            </b-row>
            <b-row>
                <b-col offset-sm="1"  sm="6">FM Build: </b-col>
                <b-col  sm="5">{{currentCent.cu_sw_ver.cu_sw_FM_build}}</b-col>
                <b-col v-if="currentCent.cu_sw_ver && currentCent.cu_sw_ver.upgradable=='NO'" offset="1" cols="12" style="text-align:left;color:grey" class="typo-littleblack" >FM firmware upgraded to latest version</b-col>
                <b-col v-else offset="1" cols="12" style="text-align:left;color:grey" class="typo-littleblack">Firmware upgrade available. FM build: {{currentCent.cu_sw_ver.cu_sw_FM_build_upg}}</b-col>
            </b-row>
            <b-row>
                <b-col offset-sm="1"  sm="6">nuBe Build: </b-col>
                <b-col  sm="5">{{currentCent.cu_sw_ver.cu_sw_Nube_build}}</b-col>
                <b-col v-if="currentCent.cu_sw_ver && currentCent.cu_sw_ver.upgradable=='NO'" offset="1" cols="12" style="text-align:left;color:grey" class="typo-littleblack" >nuBe firmware upgraded to latest version</b-col>
                <b-col v-else offset="1" cols="12" style="text-align:left;color:grey" class="typo-littleblack">Firmware upgrade available. nuBe build: {{currentCent.cu_sw_ver.cu_sw_Nube_build_upg}}</b-col>
            </b-row>
            <b-row v-if="currentCent.cu_sw_ver && currentCent.cu_sw_ver.upgradable=='YES'">
                <b-col offset="1" cols="12" style="text-align:left; color:#009DE0">
                <b-button @click="startFwUpgrade" style="padding:0px;"><i class="fa fa-refresh mr-1" style="text-align:left; color:#009DE0"></i></b-button>
                    <span>Firmware upgrade available.</span> <br>
                </b-col>
            </b-row>
        </div>
        <!-- Dettagli software sicuro -->
        <div v-if="currentCent.cu_type == 'sicuro'">
            <b-row>
                <b-col cols="6" offset-sm="1" sm="6">{{$t('details_cu_modal.firmware_version')}}: </b-col>
                <b-col cols="6" sm="5">{{currentCent.cu_sw_ver ? currentCent.cu_sw_ver.cu_sw_id : 'n/a'}}</b-col>
            </b-row>
            <b-row>
                <b-col cols="6" offset-sm="1" sm="6">{{$t('details_cu_modal.porting_build')}}: </b-col>
                <b-col cols="6" sm="5">{{currentCent.cu_sw_ver ? currentCent.cu_sw_ver.cu_sw_Porting_build : 'n/a'}}</b-col>
            </b-row>
            <b-row v-if="dispUpgradable">
                <b-col v-if="portingUpdated" offset="1" cols="12" style="text-align:left; color:grey" class="typo-littleblack" >{{$t('details_cu_modal.porting_upgraded_last_version')}}</b-col>
                <b-col v-else offset="1" cols="12" style="text-align:left; color:grey" class="typo-littleblack">{{$t('details_cu_modal.porting_upgradable')}}: {{currentCent.cu_sw_ver.cu_sw_Porting_build_upg}}</b-col>
            </b-row>
            <b-row>
                <b-col cols="6" offset-sm="1" sm="6">{{$t('details_cu_modal.interface_build')}}: </b-col>
                <b-col cols="6" sm="5">{{currentCent.cu_sw_ver ? currentCent.cu_sw_ver.cu_sw_Interfaccia_build : 'n/a'}}</b-col>
            </b-row>
            <b-row v-if="dispUpgradable">
                <b-col v-if="interfacciaUpdated" offset="1" cols="12" style="text-align:left; color:grey" class="typo-littleblack" >{{$t('details_cu_modal.interface_upgraded_last_version')}}</b-col>
                <b-col v-else offset="1" cols="12" style="text-align:left; color:grey" class="typo-littleblack">{{$t('details_cu_modal.interface_upgradable')}}: {{currentCent.cu_sw_ver.cu_sw_Interfaccia_build_upg}}</b-col>
            </b-row>
            <b-row>
                <b-col cols="6" offset-sm="1" sm="6">{{$t('details_cu_modal.nube_build')}}: </b-col>
                <b-col cols="6" sm="5">{{currentCent.cu_sw_ver ? currentCent.cu_sw_ver.cu_sw_Nube_build : 'n/a'}}</b-col>
            </b-row>
            <b-row v-if="dispUpgradable">
                <b-col v-if="nubeUpdated" offset="1" cols="12" style="text-align:left; color:grey" class="typo-littleblack" >{{$t('details_cu_modal.nube_upgraded_last_version')}}</b-col>
                <b-col v-else offset="1" cols="12" style="text-align:left; color:grey" class="typo-littleblack">{{$t('details_cu_modal.nube_upgradable')}}: {{currentCent.cu_sw_ver.cu_sw_Nube_build_upg}}</b-col>
            </b-row>

            <!-- <b-row v-if="currentCent.cu_sw_ver.upgradable=='YES'"> -->
            <b-row v-if="visualizzaButtonUpgrade">
                <b-col offset="1" cols="12" style="text-align:left; color:#009DE0">
                    <!-- :disabled="this.currentCent.cu_type == 'sicuro'" -->
                <b-button @click="startFwUpgrade" style="padding:0px;"><i class="fa fa-refresh mr-1" style="text-align:left; color:#009DE0"></i></b-button>
                    <span>Firmware upgrade available.</span> <br>
                </b-col>
            </b-row>
        </div>

        <div class="typo-label">
            <b-row v-if="currentCent.plant_code"><b-col offset-sm="1" sm="6" class="mt-4">{{$t("config_cu_modal.plant_code")}}: </b-col><b-col  class="mt-4" sm="5">{{currentCent.plant_code}}</b-col></b-row>
            <b-row v-if="currentCent.ETH0_state"><b-col offset-sm="1" sm="6">ETH0 state (Eth0 Hooked Server): </b-col><b-col  sm="5">{{currentCent.ETH0_state.ETH0_HOOKED_SERVER}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags && currentCent.cu_flags.DHCP_ETHO_DISABLED"> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.DHCP_ETHO_DISABLED")}}: </b-col><b-col  v-if="currentCent.cu_flags.DHCP_ETHO_DISABLED=='OFF'" sm="5">ON</b-col><b-col  v-else sm="5">OFF</b-col></b-row>
            <b-row v-if="currentCent.cu_flags && currentCent.cu_flags.ETHO_CLIENT_INTERNET"> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.ETHO_CLIENT_INTERNET")}}: </b-col><b-col  sm="5">{{currentCent.cu_flags.ETHO_CLIENT_INTERNET}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags && currentCent.cu_flags.WIFI_ENABLED"> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.WIFI_ENABLED")}}: </b-col><b-col  sm="5">{{currentCent.cu_flags.WIFI_ENABLED}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags && currentCent.cu_flags.WIFI_STA_MODE"> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.WIFI_STA_MODE")}}: </b-col><b-col  sm="5">{{currentCent.cu_flags.WIFI_STA_MODE}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags && currentCent.SIM_state"><b-col offset-sm="1"  sm="6">SIM state: </b-col><b-col  sm="5">{{currentCent.SIM_state}}</b-col></b-row>
            <b-row v-if="currentCent.GSM_Campo">
                <b-col offset-sm="1" sm="6"><div class="mt-3"> GSM Strenght: </div> </b-col>
                <b-col  sm="5">
                        <i class="icon__signal-strength mb-2 mt-2" v-bind:class="[GsmClass(currentCent.GSM_Campo)]">
                            <span class="bar-1"></span>
                            <span class="bar-2"></span>
                            <span class="bar-3"></span>
                            <span class="bar-4"></span>
                            <span class="bar-5"></span>
                        </i>
                </b-col>
            </b-row>
            <b-row v-if="currentCent.GSM_REG_state"><b-col offset-sm="1"  sm="6">GSM REG state: </b-col><b-col  sm="5">{{currentCent.GSM_REG_state}}</b-col></b-row>
        </div>

<!-- Connection information -->
        <hr>
        <b-row><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{ $t("details_cu_modal.connessioni_cloud")}}:</strong></b-col></b-row>
        <b-row v-if="currentCent.first_installation_timestamp"> <b-col offset-sm="1"  sm="6">{{ $t("details_cu_modal.prima_installazione")}}: </b-col><b-col  sm="5">{{moment(String(new Date(currentCent.first_installation_timestamp))).format('DD MMM YYYY - HH:mm') }} <span class="typo-littleblack">{{ currentCent.cu_location }} </span></b-col></b-row>
        <b-row> <b-col offset-sm="1" sm="6">{{ $t("details_cu_modal.aggiornamento_dati") }} </b-col><b-col sm="5">{{ currentCent.timestamp ? moment(String(new Date(currentCent.timestamp))).format('DD MMM YYYY - HH:mm'): $t("details_cu_modal.not_available") }}<span class="typo-littleblack">{{ currentCent.cu_location }} </span></b-col></b-row>
        <div v-if="currentCent.cu_type == 'sicuro'">
          <b-row> <b-col offset-sm="1" sm="6">{{ $t("details_cu_modal.ip_address") }}: </b-col><b-col sm="5">{{ currentCent.ip_address }}</b-col></b-row>
        </div>
<!-- Advanced -->
        <!-- cu flags per logica fm -->
        <div v-if="currentCent.cu_flags" class="typo-label">
        <hr>
            <b-row><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t("details_cu_modal.advanced")}}</strong></b-col></b-row>
            <b-row v-if="currentCent.cu_flags.ACTIVATE_LAST_SCENE_AT_RESET"> <b-col offset-sm="1" sm="6">{{$t("details_cu_modal.ACTIVATE_LAST_SCENE_AT_RESET")}}:</b-col><b-col  sm="3"><i v-if="currentCent.cu_flags.ACTIVATE_LAST_SCENE_AT_RESET=='ON'" class="fa fa-check" style="color:green" /><i v-else class="fa fa-close" style="color:gray" /></b-col></b-row>
            <b-row v-if="currentCent.cu_flags.SMS_ALARMS_ENABLED"> <b-col offset-sm="1" sm="6">{{$t("details_cu_modal.SMS_ALARMS_ENABLED")}}:</b-col><b-col  sm="3">{{currentCent.cu_flags.SMS_ALARMS_ENABLED}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags.CALIBRAZIONE_NOTTURNA_ENABLED"> <b-col offset-sm="1" sm="6">{{$t("details_cu_modal.CALIBRAZIONE_NOTTURNA_ENABLED")}}:</b-col><b-col  sm="3">{{currentCent.cu_flags.CALIBRAZIONE_NOTTURNA_ENABLED}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags.PASSWORD_CENLOG_ENABLED"> <b-col offset-sm="1" sm="6">{{$t("details_cu_modal.PASSWORD_CENLOG_ENABLED")}}:</b-col><b-col  sm="3">{{currentCent.cu_flags.PASSWORD_CENLOG_ENABLED}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags.LOG_RADIO_DISABLED"> <b-col offset-sm="1" sm="6">{{$t("details_cu_modal.LOG_RADIO_DISABLED")}}:</b-col><b-col  sm="3">{{currentCent.cu_flags.LOG_RADIO_DISABLED}}</b-col></b-row>
            <b-row v-if="currentCent.cu_flags.RETRY_RADIO_MSG_HIGH"> <b-col offset-sm="1" sm="6">{{$t("details_cu_modal.RETRY_RADIO_MSG_HIGH")}}:</b-col><b-col  sm="3">{{currentCent.cu_flags.RETRY_RADIO_MSG_HIGH}}</b-col></b-row>
        <!-- cu flags per sicuro -->
        <div v-if="currentCent.cu_type == 'sicuro'">
            <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.ALL_ON_TEST")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.ALL_ON_TEST == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.ALL_ON_TEST}}</b-col></b-row>
            <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.UNBLOCK_TEST")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.UNBLOCK_TEST == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.UNBLOCK_TEST}}</b-col></b-row>
            <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.MODBUS_MODE")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.MODBUS_MODE == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.MODBUS_MODE}}</b-col></b-row>
            <div v-if="currentCent.cu_system == '230'">
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.DC_PHASE_ON_UV")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.DC_PHASE_ON_UV == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.DC_PHASE_ON_UV}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.CHARGER_TEMPERATURE_COMPENSATION")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.CHARGER_TEMPERATURE_COMPENSATION == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.CHARGER_TEMPERATURE_COMPENSATION}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.CRITICAL_CIRCUIT_IN_DC")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.CRITICAL_CIRCUIT_IN_DC == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.CRITICAL_CIRCUIT_IN_DC}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.DISABLE_UV_ON_LSSA_BUS_ERR")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.DISABLE_UV_ON_LSSA_BUS_ERR == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.DISABLE_UV_ON_LSSA_BUS_ERR}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.FIRE_DISCONNECTION")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.FIRE_DISCONNECTION == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.FIRE_DISCONNECTION}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.INSULATION_TEST_AUTOMATIC_ACTIVATED")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.INSULATION_TEST_AUTOMATIC_ACTIVATED == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.INSULATION_TEST_AUTOMATIC_ACTIVATED}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.LUMINAIRE_PROGRAMMING_IN_DC")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.LUMINAIRE_PROGRAMMING_IN_DC == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.LUMINAIRE_PROGRAMMING_IN_DC}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.PROPAGATE_KSK")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.PROPAGATE_KSK == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.PROPAGATE_KSK}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.REFRESH_LUMINAIRE_PROGRAMMING")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.REFRESH_LUMINAIRE_PROGRAMMING == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.REFRESH_LUMINAIRE_PROGRAMMING}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.RESET_TIMER_STAIRWAY_PB")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.RESET_TIMER_STAIRWAY_PB == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.RESET_TIMER_STAIRWAY_PB}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.SD_IN_AC_DC_MODE")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.SD_IN_AC_DC_MODE == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.SD_IN_AC_DC_MODE}}</b-col></b-row>
                <b-row><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.SEARCH_LUM_OTHER_LINES_OFF")}}:</b-col><b-col sm="3" :style="{'color': (currentCent.cu_flags.SEARCH_LUM_OTHER_LINES_OFF == 'ON') ? 'green':'black' }">{{currentCent.cu_flags.SEARCH_LUM_OTHER_LINES_OFF}}</b-col></b-row>
            </div>
        </div>
<!-- Potential Free Contact -->
    <!-- PFC 1 -->
            <b-row v-if="pfc1IsPresent"><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.pfc_config_1")}}:</b-col><b-col  sm="3">{{ currentCent.pfc_config_1 == '0' ? $t("pfc_config_sign.not_used") : "" }}</b-col></b-row>
            <b-row v-if="pfc1IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i>{{$t("details_cu_modal.pfc_sign")}}:</b-col><b-col sm="6"><li v-for="sign in listaSignPfc1" :key="sign.id">{{sign.value}}</li></b-col></b-row>
            <b-row v-if="pfc1IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i>{{$t("details_cu_modal.pfc_conj")}}:</b-col><b-col sm="6">{{ currentCent.pfc_conjunction_1.toUpperCase() }}</b-col></b-row>
            <b-row v-if="pfc1IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i>{{$t("details_cu_modal.pfc_delay")}}:</b-col><b-col sm="6">{{ currentCent.pfc_delay_1 }} sec</b-col></b-row>
            <!-- <br v-if="pfc1IsNotZero"> -->
    <!-- PFC 2 -->
            <b-row v-if="pfc2IsPresent"><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.pfc_config_2")}}:</b-col><b-col  sm="3">{{ currentCent.pfc_config_2 == '0' ? $t("pfc_config_sign.not_used") : "" }}</b-col></b-row>
            <b-row v-if="pfc2IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i> {{$t("details_cu_modal.pfc_sign")}}:</b-col> <b-col sm="6"><li v-for="sign in listaSignPfc2" :key="sign.id">{{sign.value}}</li></b-col></b-row>
            <b-row v-if="pfc2IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i> {{$t("details_cu_modal.pfc_conj")}}:</b-col> <b-col sm="6">{{ currentCent.pfc_conjunction_2.toUpperCase() }}</b-col></b-row>
            <b-row v-if="pfc2IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i> {{$t("details_cu_modal.pfc_delay")}}:</b-col> <b-col sm="6">{{ currentCent.pfc_delay_2 }} sec</b-col></b-row>
            <!-- <br v-if="pfc2IsNotZero"> -->
    <!-- PFC 3 -->
            <b-row v-if="pfc3IsPresent"><b-col offset-sm="1" sm="8">{{$t("details_cu_modal.pfc_config_3")}}:</b-col><b-col  sm="3">{{ currentCent.pfc_config_3 == '0' ? $t("pfc_config_sign.not_used") : "" }}</b-col></b-row>
            <b-row v-if="pfc3IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i> {{$t("details_cu_modal.pfc_sign")}}:</b-col> <b-col sm="6"><li v-for="sign in listaSignPfc3" :key="sign.id">{{sign.value}}</li></b-col></b-row>
            <b-row v-if="pfc3IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i> {{$t("details_cu_modal.pfc_conj")}}:</b-col> <b-col sm="6">{{ currentCent.pfc_conjunction_3.toUpperCase() }}</b-col></b-row>
            <b-row v-if="pfc3IsNotZero"><b-col offset-sm="2" sm="4"><i class="fa fa-arrow-right" aria-hidden="true" style="text-align:left;color:grey"></i> {{$t("details_cu_modal.pfc_delay")}}:</b-col> <b-col sm="6">{{ currentCent.pfc_delay_3 }} sec</b-col></b-row>
        </div>

    </b-container>
        <!--- se cu è un blegateway -->
    <b-container fluid v-if="currentCent.cu_type=='blegateway'">
        <!-- num lamapde e lampade in errore-->
        <b-row >
            <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade")}}:</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_found}}</b-col>
        </b-row>
        <b-row v-if="currentCent.num_lamp_present"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_presenti")}}:</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_present}}</b-col></b-row>
        <b-row v-if="currentCent.num_lamp_found_dir"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_bluetooth_direct")}}:</b-col><b-col cols="2" sm="5"><br>{{currentCent.num_lamp_found_dir}}</b-col></b-row>
        <b-row v-if="currentCent.num_lamp_found_ind"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_bluetooth_not_direct")}}:</b-col><b-col cols="2" sm="5"><br>{{currentCent.num_lamp_found_ind}}</b-col></b-row>
        <b-row> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_errore")}}:</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_error}}</b-col></b-row>
        <br>

        <!-- dati anagrafici dispositivo -->
        <hr v-if="currentCent.cu_product_desc">
        <b-row v-if="currentCent.cu_product_desc"><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t('details_cu_modal.details')}}</strong></b-col></b-row>
        <b-row v-if="currentCent.cu_product_desc"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.product_desc")}}: </b-col><b-col>{{currentCent.cu_product_desc}}</b-col></b-row>
        <b-row v-if="currentCent.cu_order_code"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.order_code")}}: </b-col><b-col>{{currentCent.cu_order_code}}</b-col></b-row>
        <b-row v-if="currentCent.cu_product_code"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.product_code")}}: </b-col><b-col>{{currentCent.cu_product_code}}</b-col></b-row>
        <b-row v-if="currentCent.cu_battery_code"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.battery_code")}}: </b-col><b-col>{{currentCent.cu_battery_code}}</b-col></b-row>
        <b-row v-if="currentCent.cu_battery_desc"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.battery_desc")}}: </b-col><b-col>{{currentCent.cu_battery_desc}}</b-col></b-row>
        <b-row v-if="currentCent.cu_dimension"> <b-col offset-sm="1"  sm="4">{{$t("details_cu_modal.dimension")}}: </b-col><b-col>{{currentCent.cu_dimension}}</b-col></b-row>
        <b-row>
            <b-col offset-sm="1"  sm="4" v-if="currentCent.cu_product_pdf!=null && currentCent.cu_product_pdf!='undefined' && currentCent.cu_product_pdf!=''">{{$t("details_cu_modal.cu_pdf")}}:</b-col>
            <b-col v-if="currentCent.cu_product_pdf!=null && currentCent.cu_product_pdf!='undefined' && currentCent.cu_product_pdf!=''">
                <a :href="pathDevicePdf+currentCent.cu_product_pdf" target="_blank">
                    <span class="mr-1"><i class="fa fa-file" style="color:#009DE0"></i></span>
                    {{currentCent.cu_product_pdf}}
                </a>
            </b-col>
        </b-row>
        <hr>

        <!-- informazioni zona bluetooth -->
        <b-row><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t("bluetooth.zone_info")}}</strong></b-col></b-row>
        <b-row v-if="currentCent.zoneName"> <b-col offset-sm="1"  sm="6">{{$t("bluetooth.zone")}} </b-col><b-col  sm="5">{{currentCent.zoneName}}</b-col></b-row>
        <b-row v-if="currentCent.zone"> <b-col offset-sm="1"  sm="6">{{$t("bluetooth.zone_number")}} </b-col><b-col  sm="5">{{currentCent.zone}}</b-col></b-row>
        <hr>

        <!-- informazioni di connessione -->
        <b-row><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t("details_cu_modal.connessioni_cloud")}}</strong></b-col></b-row>
        <b-row v-if="currentCent.first_installation_timestamp"> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.prima_installazione")}} </b-col><b-col  sm="5">{{moment(String(new Date(currentCent.first_installation_timestamp))).format('DD MMM YYYY - HH:mm')}} <p class="typo-littleblack">{{currentCent.cu_location}} </p></b-col></b-row>
        <b-row> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.aggiornamento_dati")}} </b-col><b-col  sm="5">{{moment(String(new Date(currentCent.timestamp))).format('DD MMM YYYY - HH:mm')}}<p class="typo-littleblack">{{currentCent.cu_location}} </p></b-col></b-row>
        <hr>

        <!-- Specifiche tecniche e Dettagli software -->
        <b-row ><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t("details_cu_modal.specifiche_tecniche")}}</strong></b-col></b-row>
        <b-row v-if="currentCent.modwifi_sw_ver.modwifi_sw_dev_type"> <b-col offset-sm="1"  sm="6">Firmware device type: </b-col><b-col  sm="5">{{currentCent.modwifi_sw_ver.modwifi_sw_dev_type}}</b-col></b-row>
        <b-row><b-col offset-sm="1" sm="6">Firmware version: </b-col><b-col  sm="5">{{currentCent.modwifi_sw_ver.modwifi_sw_id}}</b-col></b-row>
        <b-row><b-col offset-sm="1" sm="6">Build: </b-col><b-col sm="5">{{currentCent.modwifi_sw_ver.modwifi_sw_build}}</b-col></b-row>
        <b-row v-if="currentCent.modwifi_sw_ver && currentCent.modwifi_sw_ver.upgradable=='YES'">
                <b-col offset="1" cols="12" style="text-align:left; color:#009DE0">
                <b-button v-if="currentCent.modwifi_sw_ver && currentCent.modwifi_sw_ver.upgradable=='YES'" @click="startFwUpgrade" style="padding:0px;"><i class="fa fa-refresh mr-1" style="text-align:left; color:#009DE0"></i></b-button>
                    <span>Firmware upgrade available. Build: {{currentCent.modwifi_sw_ver.modwifi_sw_build_fw_upg}} </span>
                </b-col>
        </b-row>


    </b-container>

    </b-modal>
</template>

<script>
// import Vue from 'vue'

export default {
  name: "CentDetails",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    currentCent: null,
    visible: {
      type: Boolean,
      default: false
    },
    sendUpgrade: null,
    sendEditNome: null,
    updateFinito: true,
    editingCent: false,
  },

  emits:['hide', 'change', 'updating'],

  data() {
    return {
        pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
        pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF,                        //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
        nomeCent: '',
        isVisible: false,
    };
  },

  computed: {

    updatingNameLocal() {
        return !this.updateFinito;
    },
    //serve la bidirezionalità perché la gestione della risposta del comando 'SET CU NAME' è gestita dal componente padre (CentralList)
    //quindi se il padre imposta editingCent a false, anche questo componente deve essere impostato a false
    editingCentLocal: {
      get: function() {
        console.log("editingCentLocal, currentCent.cu_desc: " + this.currentCent.cu_desc);
        return this.editingCent;
      },
      set: function(value) {
        console.log("editingCentLocal: " + value + " currentCent.cu_desc: " + this.currentCent.cu_desc);
        this.$emit('editing', value);
      }
    },
    pfc1IsPresent() {
        return this.currentCent.pfc_config_1 != undefined;
    },
    pfc1IsNotZero() {
        return ((this.currentCent.pfc_config_1 != '0') && (this.currentCent.pfc_config_1 != undefined));
    },
    pfc2IsPresent() {
        return this.currentCent.pfc_config_1 != undefined;
    },
    pfc2IsNotZero() {
        return ((this.currentCent.pfc_config_1 != '0') && (this.currentCent.pfc_config_1 != undefined));
    },
    pfc3IsPresent() {
        return this.currentCent.pfc_config_1 != undefined;
    },
    pfc3IsNotZero() {
        return ((this.currentCent.pfc_config_1 != '0') && (this.currentCent.pfc_config_1 != undefined));
    },
    listaSignPfc1() {
        return this.listaSignalsPfc(this.currentCent.pfc_config_1);
    },
    listaSignPfc2() {
        return this.listaSignalsPfc(this.currentCent.pfc_config_2);
    },
    listaSignPfc3() {
        return this.listaSignalsPfc(this.currentCent.pfc_config_3);
    },
    portingUpdated() {
        return this.currentCent.cu_sw_ver.cu_sw_Porting_build == this.currentCent.cu_sw_ver.cu_sw_Porting_build_upg;
    },
    nubeUpdated() {
        return this.currentCent.cu_sw_ver.cu_sw_Nube_build == this.currentCent.cu_sw_ver.cu_sw_Nube_build_upg;
    },
    interfacciaUpdated() {
        return this.currentCent.cu_sw_ver.cu_sw_Interfaccia_build == this.currentCent.cu_sw_ver.cu_sw_Interfaccia_build_upg;
    },
    dispUpgradable() {
        if (this.currentCent.cu_sw_ver == null) return false;
        return this.currentCent.cu_sw_ver.upgradable == 'YES';
    },
    visualizzaButtonUpgrade() {
        if ((this.currentCent.cu_sw_ver != null) && (this.currentCent.cu_sw_ver.upgradable=='YES')) {
            return (!this.portingUpdated || !this.nubeUpdated || !this.interfacciaUpdated)
        } else {
            return false;
        }
    },
    centNameInfo() {
        const nc = this.nomeCent.length ? this.nomeCent.length : 0;
        // const validChars = /^[\x20-\x7F]*$/.test(this.nomeCent);
        const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeCent);
        if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
        if (nc > 30 || !validChars) {
            return "<b style=\"color:red\">" + nc + "/30 Caratteri</b>";
        }
        return "" + nc +"/30 Caratteri";
    }

  },

  created() {
    console.log("CentralDetails created")
  },
  mounted() {
    console.log("CentralDetails di ", this.currentCent);
  },

  methods: {

    GsmClass(value) {
            if(value>=25) return "signal-5"
            if(value>=20 && value<25) return "signal-4"
            if(value>=15 && value<20) return "signal-3"
            if(value>=10 && value<15) return "signal-2"
            if(value>=1 && value<10) return "signal-1"
            return "signal-0"
        },

    //funzione che restituisce il numero di lampade in errore in un sistema SICURO a livello di centrale, andando a leggere gli errori nei propri AK
    calcolaLampInError(param) {
        var num = 0;
        param.ak.forEach( (ak) => {num = num + ak.num_lamp_error});
        //console.log("SICURO ERRORI: ", num);
        return num
    },

    //decodifica il registro di configurazione dell'uscita pfc passata come parametro e restituisce una LISTA {key, value}
    listaSignalsPfc(configReg) {
        let n = parseInt(configReg); //da stringa a numero
        let lista = [];
        //per far funzionare correttamente il ciclo for devo trattare subito il bit meno significativo
        let resto = n % 2; //il bit meno significativo
        if (resto == 1) {
            lista.push({id:1, value:this.$t("pfc_config_sign.mains_fail")});
        }
        for(let pos = 2; n > 1 ; pos++) {
            n = parseInt(n / 2); //consumo il bit e tengo solo la parte intera della divisione (parseInt)
            resto = n % 2; //calcolo il nuovo resto
            if ((resto) == 1) {
                switch (pos) {
                    case 2:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.batt_oper")});
                        break;
                    case 3:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.deep_discharge")});
                        break;
                    case 4:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.system_blocked")});
                        break;
                    case 5:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.batt_fail")});
                        break;
                    case 6:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.charger_fail")});
                        break;
                    case 7:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.circuit_lum_fail")});
                        break;
                    case 8:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.test_running")});
                        break;
                    case 9:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.critical_circuit")});
                        break;
                    case 10:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.lssa_sub_dis")});
                        break;
                    case 11:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.insul_fail")});
                        break;
                    case 12:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.temp_fail")});
                        break;
                    case 13:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.fan_main_fail")});
                        break;
                    case 14:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.fan_batt_oper")});
                        break;
                    case 15:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.fan_boost_charge")});
                        break;
                    case 16:
                        lista.push({id:pos, value:this.$t("pfc_config_sign.fan_periodically")});
                        break;
                }
            }
        }
        console.log("LISTA: ", lista);
        return lista
    },

    //decodifica il registro di configurazione dell'uscita pfc passata come parametro e restituisce una STRINGA
    pfcConfig(configReg) {
        //console.log("PFC: ", this.$t())
        let n = parseInt(configReg);
        let risp = "";
        //per far funzionare correttamente il ciclo for devo trattare subito il bit meno significativo
        let resto = n % 2; //il bit meno significativo
        if (resto == 1) {
            risp = this.$t("pfc_config_sign.mains_fail");
        }
        for(let pos = 2; n > 1 ; pos++) {
            n = parseInt(n / 2); //consumo il bit e tengo solo la parte intera della divisione (parseInt)
            resto = n % 2; //calcolo il nuovo resto
            if ((resto) == 1) {
                switch (pos) {
                    case 2:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.batt_oper");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.batt_oper");
                        }
                        break;
                    case 3:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.deep_discharge");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.deep_discharge");
                        }
                        break;
                    case 4:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.system_blocked");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.system_blocked");
                        }
                        break;
                    case 5:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.batt_fail");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.batt_fail");
                        }
                        break;
                    case 6:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.charger_fail");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.charger_fail");
                        }
                        break;
                    case 7:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.circuit_lum_fail");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.circuit_lum_fail");
                        }
                        break;
                    case 8:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.test_running");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.test_running");
                        }
                        break;
                    case 9:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.critical_circuit");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.critical_circuit");
                        }
                        break;
                    case 10:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.lssa_sub_dis");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.lssa_sub_dis");
                        }
                        break;
                    case 11:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.insul_fail");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.insul_fail");
                        }
                        break;
                    case 12:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.temp_fail");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.temp_fail");
                        }
                        break;
                    case 13:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.fan_main_fail");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.fan_main_fail");
                        }
                        break;
                    case 14:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.fan_batt_oper");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.fan_batt_oper");
                        }
                        break;
                    case 15:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.fan_boost_charge");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.fan_boost_charge");
                        }
                        break;
                    case 16:
                        if (risp == "") {
                            risp = this.$t("pfc_config_sign.fan_periodically");
                        } else {
                            risp = risp + "; " + this.$t("pfc_config_sign.fan_periodically");
                        }
                        break;
                }
            }
        }
        if (risp == "") {
            return this.$t("pfc_config_sign.not_used")
        } else {
            return risp;
        }
    },
    //si attiva con l'evento 'change'
    change(visible) {

        this.$emit("change", visible);
    },
    hide() {
        this.$emit("hide");
    },

    //verifica se una qualsiasi Centrale ha un errore o meno
    NessunErroreCentrale(tipo) {
        switch(tipo) {
            case "sicuro":
                return (
                    this.currentCent.cu_error.error_general == "OFF"
                    //OPPURE SI VERIFICANO TUTTI GLI ERRORI UNO AD UNO
                )
            case "cablecom":
                return (
                    this.currentCent.cu_error.error_batt_low_voltage=="OFF" &&
                    this.currentCent.cu_error.error_batt_not_connected=="OFF" &&
                    this.currentCent.cu_error.error_duplicated_id_lamp=="OFF" &&
                    this.currentCent.cu_error.error_lg=="OFF" &&
                    this.currentCent.cu_error.error_wiring=="OFF" &&
                    this.currentCent.cu_error.error_too_much_lamp_in_config=="OFF" &&
                    this.currentCent.cu_error.error_overload=="OFF" &&
                    this.currentCent.cu_error.error_missing_lamp_in_config=="OFF" &&
                    this.currentCent.cu_error.error_more_32_lamp_in_config=="OFF"
                )
            case "logica":
                return (
                    this.currentCent.cu_error.error_batt_low_voltage=="OFF" &&
                    this.currentCent.cu_error.error_batt_not_connected=="OFF" &&
                    this.currentCent.cu_error.error_duplicated_id_lamp=="OFF" &&
                    this.currentCent.cu_error.error_lg=="OFF" &&
                    this.currentCent.cu_error.error_wiring=="OFF" &&
                    this.currentCent.cu_error.error_too_much_lamp_in_config=="OFF" &&
                    this.currentCent.cu_error.error_overload=="OFF" &&
                    this.currentCent.cu_error.error_missing_lamp_in_config=="OFF" &&
                    this.currentCent.cu_error.error_more_128_lamp_in_config=="OFF"
                )
            case "logicafm":
                return (
                    this.currentCent.cu_error.err_data_invalid=="OFF" &&
                    this.currentCent.cu_error.err_UART1=="OFF" &&
                    this.currentCent.cu_error.err_UART2=="OFF" &&
                    this.currentCent.cu_error.err_UART3=="OFF" &&
                    this.currentCent.cu_error.err_UART3_modem_powerON=="OFF" &&
                    this.currentCent.cu_error.err_UART4=="OFF" &&
                    this.currentCent.cu_error.err_UART5=="OFF" &&
                    this.currentCent.cu_error.err_UART6=="OFF" &&
                    this.currentCent.cu_error.err_UART7=="OFF" &&
                    this.currentCent.cu_error.err_data_invalid=="OFF" &&
                    this.currentCent.cu_error.mancanza_rete=="OFF" &&
                    this.currentCent.num_lamp_error<=0 &&
                    this.currentCent.num_nodi_orfani<=0
                )
        }
    },

    startFwUpgrade() {
        this.$store.dispatch('sendLogicaCommand', {cu_command: 'startFwUpgrade',cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, nitialRetry: 3});
        this.hide();
    },

    checkFwUpgrade() {
        this.$store.dispatch('sendLogicaCommand', {cu_command: 'checkFwUpgrade',cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, initialRetry: 3});
        this.hide();
    },

    //abilita l'input per cambiare il nome della Centrale
    editNomeCent() {
        this.nomeCent = this.currentCent.cu_desc;
        this.editingCentLocal = true;
        console.log("MODAL editingCentLocal ", this.editingCentLocal)
    },

    abortNomeCent() {
        this.editingCentLocal = false;
    },
    //esegue il cambio del nome, incaricando lo store di aggiornare il database
    saveNomeCent() {
        //const validChars = /^[\x20-\x7F]*$/.test(this.nomeCent);
        const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeCent);
        if (!validChars) {
            this.$bvModal.msgBoxOk("La descrizione della centrale non può contenere caratteri speciali e lettere accentate");
            return;
        }

        if (this.nomeCent.length > 30) {
            this.$bvModal.msgBoxOk("La descrizione della centrale non può superare i 30 caratteri");
            return;
        }

        this.$store.dispatch('sendCablecomCommand', {cu_command: 'setCuName',cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, cuName: this.nomeCent});
        this.$emit('updating');
        console.log("MODAL updatingName = ", this.updatingNameLocal)
   },
   //funzione che viene chiamata quando il modal diventa visibile
   initModal() {
        this.nomeCent = "";
   },
 }
};
</script>

<style lang="scss">
  li {
    list-style: none;
  }
  #tab_advanced .nav-tabs{
        font-weight: bold;
    }
  .typo-data{
    font-weight:400;
    font-family: Roboto;
    font-size: 13px;
  }
  .modal-body {
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
